/* --------------------------------------------------------------------------------------
   scan.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

const scan  = {
    template: require('./scan.html'),
    controller: 'scanCtrl',
    controllerAs: 'vm',
    bindings: {
      back: '&'
    }
}

export default scan



// WEBPACK FOOTER //
// ./src/app/gradeTests/components/scan.component.js